import { useCallback, useMemo } from 'react';

import AutocompleteWithChips from 'components/Basic/AutocompleteWithChips/AutocompleteWithChips';
import { SelectedItemDto } from 'types/CodegenReportTypes';
import { useGetLookupPracticeSessionTypes } from 'hooks/CodegenLookupHooks';
import { useTranslation } from 'react-i18next';

type Props = {
  playerType: 'Batter' | 'Pitcher';
  selectedPracticeSessionTypeId: string | undefined;
  onChange: (level: SelectedItemDto) => void;
};

const SelectPracticeSessionType = ({ playerType, selectedPracticeSessionTypeId, onChange }: Props) => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetLookupPracticeSessionTypes(playerType);

  const allOptionIds = useMemo(() => data?.map((datum) => datum.id) ?? [], [data]);
  const getOptionName = useCallback(
    (id: string) => {
      const name = data?.find((datum) => datum.id === id)?.name;
      return name != null ? t(name) : (t('Nonexistent practice session type') as string);
    },
    [data]
  );

  return (
    <AutocompleteWithChips
      label={t('PracticeSessionType')}
      options={allOptionIds}
      selected={selectedPracticeSessionTypeId ?? ''}
      setSelected={(id) => onChange({ id: id, name: getOptionName(id) })}
      getOptionLabel={(option) => (isLoading ? t('Loading practice session types...') : getOptionName(option))}
      noOptionsText={isLoading ? t('Loading practice session types...') : t('No practice session types found')}
      single
    />
  );
};

export default SelectPracticeSessionType;
